// LEN-213 (designer D1): step-check definitions and a step's bindings (AiStepChecksController).
// The API has full CRUD; the designer reads them only, until D2.
export class AiStepChecksApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getStepChecks({ signal } = {}) {
    return this.#http.get('/ai-step-checks', { signal });
  }

  async getStepCheckBindings({ stepId, signal }) {
    return this.#http.get(`/api/ai-process-steps/${stepId}/checks`, { signal });
  }
}
